'use client'

import Script from 'next/script'

type Props = {
  clientToken?: string
  applicationId?: string
  service?: string
  env?: 'local' | 'stage' | 'production'
  site?: string
  sessionSampleRate?: number
  sessionReplaySampleRate?: number
  version?: string
}

export function DatadogRum({
  clientToken,
  applicationId,
  service,
  env,
  site = 'datadoghq.com',
  sessionSampleRate = 100,
  sessionReplaySampleRate = 5,
  version,
}: Props) {
  if (!clientToken || !applicationId || !service || !env) {
    return null
  }

  return (
    <Script id="datadog-rum">
      {`
          (function(h,o,u,n,d) {
            h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
            d=o.createElement(u);d.async=1;d.src=n
            n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
          })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v6/datadog-rum.js','DD_RUM')
          window.DD_RUM.onReady(function() {
            window.DD_RUM.init({
              clientToken: '${clientToken}',
              applicationId: '${applicationId}',
              site: '${site}',
              service: '${service}',
              env: '${env}',
              version: '${version ?? ''}',
              sessionSampleRate: ${sessionSampleRate},
              sessionReplaySampleRate: ${sessionReplaySampleRate},
              trackResources: true,
              trackLongTasks: true,
              trackUserInteractions: true,
            });
          })
        `}
    </Script>
  )
}
